module.exports = __webpack_public_path__ + "static/img/logoWrite.bf8f114.png";


//////////////////
// WEBPACK FOOTER
// ./static/logoWrite.png
// module id = XmQ5
// module chunks = 1